import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient, ApiClientWithAuth } from '@/services/api/client'

const namespace: string = 'inquiry'

export type InquiryKind = 'restock' | 'new_stock'
export type AppKind = 'mail' | 'line'
export interface Inquiry {
  resource_id: string
  application_event?: {
    is_notified: boolean
  }
  inquiry_app_kind?: AppKind
}
interface RegisterParams {
  sku_id: string
  inquiry_kind: InquiryKind
  app_kind: AppKind
  email?: string
}

/**
 * LINEによるリクエストが実装される以前はメールのみでよかったため、inquiry_app_kindは存在しなかった。
 * したがって、その時点に生成されたinquiryリソースにはinquiry_app_kindが定義されていない。
 * 後方互換性のためinquiry_app_kindがundefinedの場合はmailとみなす。
 */
export function parseInquiryAppKind(inquiry: Inquiry): AppKind {
  return inquiry.inquiry_app_kind || 'mail'
}

export class InquiryService {
  constructor(
    private readonly brandEnglishName: string,
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}

  async register(params: RegisterParams): Promise<Either<Error, object>> {
    try {
      const { sku_id, ...postParams } = params
      const response = await this.apiClient.post(this.createPath(sku_id), postParams)

      const result = response.body

      log.debug({ service: `${namespace}/register`, response })

      return new Right(result)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  async fetchUserInquiries(skuId: string, inquiryKind: InquiryKind): Promise<Either<Error, Inquiry[]>> {
    try {
      const response = await this.apiClient
        .get(`${this.createPath(skuId)}?inquiry_kind=${inquiryKind}`)

      log.debug({ service: `${namespace}/list`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  private createPath(skuId: string): string {
    return `/api/user/${this.brandEnglishName}/item/sku/request_notification/${skuId}`
  }
}
